import { OrganizationType } from "../../types/organizationType";
import TextLink from "../TextLinks";
import { Text } from "../Type";
import { formatAddress } from "../../utils/formatAddress";
import styles from "./index.module.scss";

import { PencilEdit } from "../../components/Icons/general-interface-2";

type PropsType = {
  organization: OrganizationType;
  isAuth?: boolean;
  onClick?: () => void;
  editable?: boolean;
};

const OrganizationCard = ({ organization, isAuth, onClick, editable }: PropsType) => {
  if (!organization)
    return (
      <>
        <div className={styles.warningContainer}>
          <Text size="large">
            Please select an organization.
          </Text>
          {isAuth && editable && (
            <div className={styles.locationFlex}>
              <TextLink
                icon={<PencilEdit />}
                edit
                onClick={onClick}
              >
                Edit
              </TextLink>
            </div>
          )}
        </div>
      </>
    );
  return (
    <div className={styles.container}>
      <div>
        <Text size="large" className={styles.heading}>
          {organization.name}
        </Text>
        <div className={styles.address}>
          {organization.address ? (
            formatAddress(organization.address)
          ) : (
            <Text>No Address</Text>
          )}
        </div>
      </div>
      {editable &&
        <TextLink
          icon={<PencilEdit />}
          edit
          onClick={onClick}
        >
          Edit
        </TextLink>
      }
    </div>
  );
};

export default OrganizationCard;
